import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { getPortalUser } from "@/lib/portalAuth";
import { getAdminUser } from "@/lib/adminAuth";

// Persistent per-tab session ID so a page journey can be reconstructed
// server-side without any personal identifier.
function getOrCreateSession() {
  let sid = sessionStorage.getItem("zca_session_id");
  if (!sid) {
    sid =
      "s_" +
      Math.random().toString(36).slice(2) +
      Date.now().toString(36);
    sessionStorage.setItem("zca_session_id", sid);
  }
  return sid;
}

export default function VisitTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Skip admin routes — school leadership browsing the dashboard should
    // NOT pollute their own web stats.
    if (pathname.startsWith("/admin")) return;

    const parent = getPortalUser();
    const admin = typeof getAdminUser === "function" ? getAdminUser() : null;
    const email = parent?.email || admin?.email || "";

    api.post("/visits/track", {
      session_id: getOrCreateSession(),
      path: pathname + (search || ""),
      referrer: document.referrer || "",
      user_agent: navigator.userAgent,
      is_logged_in: Boolean(parent || admin),
      email,
    }).catch(() => {});
  }, [pathname, search]);

  return null;
}
